import React from 'react';
import Button from '../../shared/Button';
import { useToast } from '../../../contexts/ToastContext';
import styles from './Services.module.css';

const Services = ({ data }) => {
  const { showInfo } = useToast();
  
  if (!data) return null;

  const handleDownloadSampleReport = () => {
    // Check if the file exists
    const link = document.createElement('a');
    link.href = '/sample-report.pdf';
    link.download = 'Analytica-X-Sample-Report.pdf';
    
    // Add error handling for missing file
    link.onerror = () => {
      showInfo('Sample report is being prepared. Please contact sales@analyticax.in for a demo report.');
    };
    
    // Try to download, if it fails, show message
    try {
      link.click();
      // If we get here, the file might not exist, so show info message
      setTimeout(() => {
        showInfo('Sample report is being prepared. Please contact sales@analyticax.in for a demo report.');
      }, 1000);
    } catch (error) {
      showInfo('Sample report is being prepared. Please contact sales@analyticax.in for a demo report.');
    }
  };

  const handleCtaClick = (ctaText) => {
    if (ctaText === 'Download Sample Report') {
      handleDownloadSampleReport();
    }
  };

  return (
    <section id="services" className={`${styles.servicesSection} section`}>
      <div className="container">
        <h2 className="section-title fade-in">{data.title}</h2>
        <div className={`${styles.servicesGrid} fade-in`}>
          {data.items?.map((item, idx) => (
            <div key={idx} className={styles.serviceCard}>
              <div className={styles.serviceIcon} aria-hidden>
                {item.icon}
              </div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              {item.features && (
                <ul className={styles.featuresList}>
                  {item.features.map((f, i) => (
                    <li key={i}>{f}</li>
                  ))}
                </ul>
              )}
              {item.cta && (
                <Button 
                  variant="secondary" 
                  onClick={() => handleCtaClick(item.cta)}
                  className={styles.ctaButton}
                >
                  {item.cta}
                </Button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;


